<!--
Author: tianyi
Date: 2019-10-23
Desc: 修改交易密码密码页面，由index.js 配置引入
 -->
<template>
    <div :class="'view-change-tpwd view bg-white ' + className">
        <comp-title :title="title" />
        <change-pwd :way="way" />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import changePwd from "@/components/acctInfo/changePwd.vue";
export default {
    name: "ChangeTpwd",
    components: {
        changePwd
    },
    mixins: [mixin],
    data () {
        return {
            way: "trade"
        };
    },
    methods: {
    }
};
</script>
